<template>
    <div class="card totalCost">
        <div class="p-card-header">
            <p class="title bold">{{ $t("totalCost.title") }}</p>
        </div>
        <div
            class="p-card-content"
            v-for="(period, index) of Object.keys(costs)"
            v-if="costs[period].subscribes.length > 0"
        >
            <p class="subtitle" v-if="period === 'monthly'">Aylık Ödemeler</p>
            <p class="subtitle" v-if="period === 'oneTime'">Tek Seferlik Ödemeler</p>
            <div v-for="(subscribe, index) of costs[period].subscribes" :key="index">
                <a-row>
                    <a-col :span="11">
                        <p class="packageName semiBold">{{ subscribe.plan.title }}</p>
                    </a-col>
                </a-row>
                <a-row>
                    <div class="cost-content listcontent">
                        <p>
                            {{ subscribe.plan.altTitle }}
                            <span class="cost" v-if="subscribe.plan.type == 'supsis'">
                                {{ ~~(subscribe.plan.price || 0) }} x ({{ subscribe.details.agentCount }})
                                {{ $t("totalCost.currency") }}
                            </span>
                            <span
                                class="cost"
                                v-else-if="
                                    subscribe.plan.type == 'whatsapp-business' || subscribe.plan.type == 'whatsapp'
                                "
                            >
                                {{ ~~(subscribe.plan.price || 0) }} x ({{ subscribe.details.whatsappChannel }})
                                {{ $t("totalCost.currency") }}
                            </span>
                            <span class="cost" v-else>
                                {{ ~~(subscribe.price || 0) }} {{ $t("totalCost.currency") }}
                            </span>
                        </p>
                        <p v-if="subscribe.discount > 0">
                            Paket İndirimi
                            <span class="cost discount-cost"> -{{ ~~subscribe.discount }}₺</span>
                        </p>
                    </div>
                </a-row>
            </div>
            <div class="cost-total">
                <p class="cost bold" v-if="period === 'monthly'">
                    {{ (costs[period].total || 0).toFixed(2) }}₺ / Aylık
                </p>
                <p class="cost bold" v-if="period === 'oneTime'">
                    {{ (costs[period].total || 0).toFixed(2) }}₺ / Tek Seferlik
                </p>
            </div>
            <a-row v-if="costs.oneTime.total > 0 && period === 'oneTime'">
                <div class="total-cost-content listcontent">
                    <p>
                        Toplam Tek Seferlik Çekilecek Tutar (+ %{{ taxRate }} KDV)
                        <span class="cost discount-cost bold"
                        >{{ (costs.oneTime.total + (costs.oneTime.total * taxRate) / 100).toFixed(2) }}
                            {{ $t("totalCost.currency") }}
                        </span>
                    </p>
                </div>
            </a-row>
            <a-row v-if="costs.monthly.total > 0 && period === 'monthly'">
                <div class="total-cost-content listcontent">
                    <p>
                        Her Ay Çekilecek Toplam Tutar (+ %{{ taxRate }} KDV)
                        <span class="cost discount-cost bold"
                        >{{ (costs.monthly.total + (costs.monthly.total * taxRate) / 100).toFixed(2) }}
                            {{ $t("totalCost.currency") }}
                        </span>
                    </p>
                </div>
            </a-row>
        </div>
        <div class="p-card-footer">
            <a-row v-if="site.coupon && site.coupon.code">
                <p class="code-label">Referans Kodu</p>
                <div class="input-group coupon-code mb-3">
                    <div class="coupon-name">{{ site.coupon.code }}</div>
                    <div class="coupon-discount">({{ site.coupon.discount }}%)</div>
                </div>
            </a-row>
            <a-row v-if="((site.partner && site.partner.name) || 'manuel') === 'manuel'">
                <p class="code-label">{{ $t("totalCost.referenceCode") }}</p>
                <div class="input-group discount-code mb-3">
                    <input
                        type="text"
                        class="form-control"
                        v-model="referenceCode"
                        :placeholder="$t('totalCost.referencePlaceholder')"
                    />
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" @click="applyCouponCode">
                            {{ $t("totalCost.codeButton") }}
                        </button>
                    </div>
                </div>
            </a-row>
        </div>
        <div class="footer">
            <a-row v-if="costs.monthly.total > 0">
                <a-col class="cost-label" :span="17">{{ $t("totalCost.monthlyCost") }}</a-col>
                <a-col class="cost" :span="7"
                    >{{ (costs.monthly.total + (costs.monthly.total * taxRate) / 100 || 0).toFixed(2) }}₺
                </a-col>
            </a-row>
            <a-row v-if="costs.oneTime.total > 0">
                <a-col class="cost-label" :span="17">{{ $t("totalCost.oneTimeFullCost") }}</a-col>
                <a-col class="cost" :span="7"
                    >{{ (costs.oneTime.total + (costs.oneTime.total * taxRate) / 100 || 0).toFixed(2) }}₺
                </a-col>
            </a-row>
        </div>
        <button
            :disabled="disableCompleteButton"
            class="card-footer btn btn-outline-secondary last-button"
            @click="complateWizard"
        >
            Devam Et
        </button>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";
import { mapActions, mapState } from "vuex";

const log = log2("TotalCost");

export default {
    name: "TotalCost",
    props: {
        subscribes: {
            default: {},
        },
        disableCompleteButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            site: (state) => state.site.site,
        }),
    },
    data() {
        const costs = {
            monthly: {
                total: 0,
                discount: 0,
                subscribes: [],
            },
            oneTime: {
                total: 0,
                discount: 0,
                subscribes: [],
            },
        };

        for (const sub of Object.keys(this.subscribes).filter((sub) => this.subscribes[sub].plan)) {
            const period = this.subscribes[sub].period;
            if (period === "monthly") {
                costs.monthly = {
                    total: costs.monthly.total + (this.subscribes[sub].price - this.subscribes[sub].discount),
                    discount: costs.monthly.discount + (this.subscribes[sub].price - this.subscribes[sub].discount),
                    subscribes: [...costs.monthly.subscribes, this.subscribes[sub]],
                };
            } else {
                costs.oneTime = {
                    total: costs.oneTime.total + (this.subscribes[sub].price - this.subscribes[sub].discount),
                    discount: costs.oneTime.discount + (this.subscribes[sub].price - this.subscribes[sub].discount),
                    subscribes: [...costs.oneTime?.subscribes, this.subscribes[sub]],
                };
            }
        }

        return {
            referenceCode: null,
            taxRate: 20,
            costs,
        };
    },
    methods: {
        ...mapActions({
            applyCoupon: "site/applyCouponCode",
            getPlans: "site/getSitePlans",
        }),
        complateWizard() {
            this.$emit("submit", this.referenceCode);
        },
        applyCouponCode() {
            this.applyCoupon(this.referenceCode).then(async (coupon) => {
                if (coupon.isValid) {
                    await this.getPlans();
                    this.$toasted.success("Kupon başarılı bir şekilde uygulandı.", {
                        duration: 3000,
                        position: "top-center",
                    });
                } else {
                    this.$toasted.error("Kupon kodu hatalı veya süresi dolmuş.", {
                        duration: 3000,
                        position: "top-center",
                    });
                }
            });
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
$base-color: #000000;
$second-color: #ec4b1d;

.card {
    border-radius: 20px;
    padding: 0 !important;
}

.totalCost {
    color: $base-color;
    font-family: Poppins;
    width: 495px;
    height: auto;

    .code-label {
        font-weight: bold;
    }

    .coupon-code {
        display: flex;
        align-items: center;
        gap: 3px;
        font-size: 15px;

        .coupon-code {
            font-weight: bold;
        }

        .coupon-discount {
            font-weight: 300;
            font-size: 12px;
        }
    }

    .p-card-header {
        padding: 24px 24px 0 24px;

        .title {
            font-size: 30px;
        }
    }

    .p-card-content {
        padding: 0 24px;
    }

    .subtitle {
        font-size: 23px;
    }

    .packageName {
        margin-bottom: 0.5rem;
    }

    .cost-content {
        font-family: Quicksand;
        font-weight: 500;
        font-size: 12px;
        color: #7f7f7f;

        span {
            font-family: Poppins;
            color: $base-color;
        }

        &.listcontent {
            margin-bottom: 1rem;

            p {
                margin-bottom: 0.5rem;
            }
        }
    }

    .underline {
        text-decoration: underline;
        color: #92929d;
    }

    .active {
        color: $second-color;
    }

    .cost-total {
        color: $second-color;
        border-top: 1px solid #eeeeee;
    }

    p {
        &.cost {
            font-size: 15px;
            text-align: right;
            margin-top: 1rem;
        }

        span {
            &.cost {
                font-size: 15px;
                float: right;
            }
        }
    }

    .bold {
        font-weight: 700;
    }

    .semiBold {
        font-weight: 600;
    }

    .discount-cost {
        color: #6dd400 !important;
    }

    .p-card-footer {
        padding: 0 24px;

        .ant-row {
            margin-bottom: 1rem;
        }

        p {
            font-family: Quicksand;
            font-size: 15px;
            margin-bottom: 0.5rem;
        }

        .discount-code {
            input {
                border-color: #eeeeee;
                height: 50px;
            }

            button {
                width: 110px;
                background-color: $second-color;
                color: #ffffff;
                border-color: #eeeeee;
                font-weight: 600;
            }
        }

        .final-cost {
            background-color: #fafafa;
        }
    }

    .footer {
        padding: 24px 24px 0 24px;
        background-color: #00000008;
        font-size: 16px;
        font-weight: 600;
        text-align: end;

        .ant-row {
            padding-bottom: 1rem;
        }

        .cost-label {
            font-weight: 600;
        }

        .cost {
            font-size: 17px;
            padding-left: 5px;
            color: $second-color;
        }
    }

    .card-footer {
        border-color: #eeeeee00;
        border-radius: 0 0 20px 20px;
        background-color: $second-color;
        color: #ffffff;
        font-weight: 600;
        height: 50px;

        &.classic-border {
            border-radius: 0 !important;
        }

        &.last-button {
            margin-top: 1px;
        }
    }
}
</style>
